<template>
  <div class="box">
    <DetailsHead img="./img/bj2.png" title="企业风采" remarks="Chain Style" />

    <TopBreadcrumb :data="[
        { label: '产业链情况', path: '/industrialchain/chainstyle' },
        { label: '企业风采', path: '/industrialchain/chainstyle' },
        { label: '详情' },
      ]" />

    <div class="details-con" v-loading="loading">
      <div class="details-head">
        <div class="title">{{data.title}}</div>
        <div class="more">
          <div>阅读量: {{ data.count }}&nbsp;&nbsp;时间: {{new Date(data.createDate).formatCode('yyyy-MM-DD')}}&nbsp;&nbsp;官网: 
            <a v-if="data.sourceUrl" :href="data.sourceUrl" target="_blank">{{data.sourceUrl}}</a>
            <span v-else>无</span>
          </div>
          <div>【<span @click="$print()">打印</span>】 收藏 【字体:<span @click="size='3'">大</span> <span @click="size='2'">中</span> <span @click="size='1'">小</span>】</div>
        </div>
      </div>
      <h1 class="title-2">
        {{data.title}}
      </h1>
      <div class="text">
        <p class="content-box" :size="size" v-html="data.content"></p>
      </div>
      <!-- <EnclosureBox  :urls="data.enclosure"/> -->
      <!-- <div class="enclosure">
        <span>附件：</span>
        <span v-if="!data.enclosure">无</span>
        <span v-if="data.enclosure" style="color: rgba(46, 44, 193, 1); margin-left: 15px;cursor: pointer;" @click="$winOpen(data.enclosure)">下载</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import TopBreadcrumb from "@/components/TopBreadcrumb.vue";
import DetailsHead from "@/components/DetailsHead.vue";
import EnclosureBox from "../comp/EnclosureBox.vue";
import { getDocumentDetails } from "@/api/chainStyle.js";
import "@/assets/less/details-box.less";
export default {
  name: "Home",
  components: { DetailsHead, TopBreadcrumb,EnclosureBox },
  data() {
    return {
      loading: false,
      data: {},
      size: "2",
    };
  },
  mounted() {
    this.loading = true;
    getDocumentDetails(this.$route.params.id)
      .then((res) => {
        this.data = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

